import { render } from "./UserGroupProjectPermissionForm.vue?vue&type=template&id=04ff8ad4&scoped=true"
import script from "./UserGroupProjectPermissionForm.vue?vue&type=script&lang=ts"
export * from "./UserGroupProjectPermissionForm.vue?vue&type=script&lang=ts"

import "./UserGroupProjectPermissionForm.vue?vue&type=style&index=0&id=04ff8ad4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04ff8ad4"

export default script